export const getTRCodeByNaPm = (NaPm: string): string => {
  if (!NaPm) return null

  const decodeNaPm = decodeURIComponent(NaPm)
  if (!decodeNaPm) return null

  const splitNaPm = decodeNaPm.split('|')
  const code = splitNaPm.find(parameter => parameter.startsWith('tr='))
  return (code && code.replace('tr=', '')) || null
}
